import { render } from "./BulkJobsList.vue?vue&type=template&id=fab8d3c8&scoped=true"
import script from "./BulkJobsList.vue?vue&type=script&lang=js"
export * from "./BulkJobsList.vue?vue&type=script&lang=js"

import "./BulkJobsList.vue?vue&type=style&index=0&id=fab8d3c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fab8d3c8"]])

export default __exports__